import React from "react";
import "./MultipleAssignmentviewPopup.css";

function MultipleAssignmentStaticContent(courseType, assignment) {

    // console.log("courseType",courseType);
    // console.log("assignment",assignment);

    const totalQuestions = courseType?.assignment?.assignment_json.length
    const totalTime = courseType?.assignment?.duration_minutes
    const assignmentType = courseType?.courseType

    return (
        <>
            <div className="maltiple-assignment-static-content-container">
                <p>Instructions :</p>
                <ul className="maltiple-assignment-static-content-folder">
                    <li>Read the question carefully before selecting your answer.</li>
                    <li>Choose the letter corresponding to the option you believe is the correct answer.</li>
                    <li>You can only select one option per question.</li>
                    <li>There are no penalties for incorrect answers, so attempt all questions.</li>
                    <li>After completing the quiz, click the "Submit" button to view your score.</li>
                    {assignmentType === 2 && (
                    <>
                        <li>Please note, this assignment will be automatically submitted once the allotted time expires.</li>
                        <li>Total questions: {totalQuestions}</li>
                        <li>Total time allotted: {totalTime} minutes </li>
                    </>
                    )}
                </ul>
            </div>
        </>
    );
}

export default MultipleAssignmentStaticContent;
